<template>

    <div class="p-3 text-darker-blue flex flex-col border-t border-darker-blue">

        <div class="text-sm font-bold mb-1">&copy; {{ $page.props.app.name }}</div>

        <div class="text-xs">

            <span>{{ $page.props.app.version_type }} v{{ $page.props.app.version }}</span>

            <Link class="text-darker-blue hidden"
                :href="route('changelog')"
            >{{ __('Changelog') }}</Link>

        </div>

    </div>

</template>
<script>
import { defineComponent } from 'vue';
import Link from "./Link";

export default defineComponent({
    components: {
        Link
    }
});

</script>
